import React from 'react';
import ContactListBase from './ContactListBase';

// Lists all persons, whatever their contact type
const PersonList: React.FC = () => {
    return (
        <ContactListBase
            listKey='contact_person'
            objectName='person.general.object_name'
            defaultParams={{ entity_type: 'person' }}
            formLinkedItem={{ entity_type: 'person' }}
            showTypeFilter
            typeFilterOptions={['contact', 'lead', 'client']}
        />
    );
};

export default PersonList;
